module.exports = __webpack_public_path__ + "static/media/image25.3515ce4d.JPG";